<template>
  <el-cascader
    :options="options"
    :placeholder="inputPlaceholder"
    @change="changeProduct"
    :props="{ checkStrictly: true }"
    clearable
    v-model="result"
    ref="cascader"
  ></el-cascader>
</template>

<script>
import { areaTree } from "@/api/CaseManage";
export default {
  data() {
    return {
      options: [],
      result: []
    };
  },
  props: {
    inputPlaceholder: {
      type: String,
      default: "请选择省份/市"
    },
    prop: {
      type: String,
      default: ""
    }
  },
  methods: {
    // 切换商品类型
    changeProduct(node) {
      let modelParentId = null;
      let modelId = null;
      this.result = [];
      console.log(node, "node");
      if (node.length == 1) {
        modelParentId = node[0];
        this.result = [modelParentId];
      } else if (node.length == 2) {
        modelParentId = node[0];
        modelId = node[1];
        this.result = [modelParentId, modelId];
      }
      console.log(this.result);
      this.$emit("changeP", this.result);
      // this.$emit("input", result);
    },
    initOptions() {
      areaTree().then(ret => {
        if (ret.code === 0) {
          let list =
            ret.data.map(province => {
              const newProvince = {
                code: province.code,
                name: province.name,
                items: province.items.map(city => ({
                  code: city.code,
                  name: city.name
                }))
              };
              return newProvince;
            }) || [];
          list = list.map(item => {
            let obj = {
              label: item.name,
              value: item.code
            };
            obj.children = item.items.map(item1 => {
              let obj = {
                label: item1.name,
                value: item1.code
              };
              obj.children = item1.items?.map(item2 => {
                let obj =
                  {
                    label: item2.name,
                    value: item2.code
                  } || [];
                return obj;
              });
              return obj;
            });
            return obj;
          });

          this.options = list;
        }
      });
    },
    resetCascaderInput() {
      this.result = [];
    }
  },
  mounted() {
    this.initOptions();
  }
};
</script>

<style lang="scss" scoped></style>
